import React from 'react';
import WikiIcon from './WikiIcon';
import { useWikiUi } from './wikiUi';

const selectToast = (state) => state.toast;

/**
 * The global Wiki toast (prototype `wkToastOn`, A §1.1 / E2 §4): a dark pill
 * at the bottom centre with a teal check, one message at a time, auto-hidden
 * after 3800 ms by the `wikiUi` store. No close button, no variants — the
 * check icon is used even for denial messages, as in the prototype.
 *
 * Mounted once by `pages/WikiV2.jsx`; raise it with `wikiUi.toast(message)`.
 * The polite live region stays mounted so each message is announced.
 */
export default function WikiToast() {
    const toast = useWikiUi(selectToast);
    return (
        <div className="wk-toast-region" role="status" aria-live="polite" aria-atomic="true">
            {toast && (
                <div key={toast.id} className="wk-toast" data-testid="wiki-toast">
                    <WikiIcon name="circle-check" size={16} className="wk-toast-icon" />
                    <span className="wk-toast-msg">{toast.message}</span>
                </div>
            )}
        </div>
    );
}
